




























































































































import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
} from "vant";
import api from "../../../components/http/api";
import { RecommendInfo } from "./RecommendApi";
import vueQr from "vue-qr";
Vue.use(vueQr);

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
  },
})
export default class MerchantRecommendHome extends Vue {
  private recommendInfo: RecommendInfo = {} as RecommendInfo;

  private loadNumUp = 5;
  private pageNum = 0;
  private loading: boolean = false;
  private finished: boolean = false;
  private infoList = [];

  private showQRCode: boolean = false;
  private showRecommendExplain: boolean = false;

  private qrCodeText: string = "";

  private merchantcode: string = "";

  protected created() {
    this.merchantcode = this.$route.params.merchantcode;
    this.getRecommendBaseInfo();
  }

  protected getRecommendBaseInfo() {
    api
      .post("/weixinmp/xsyx/recommend/getRecommendInfo", {
        merchantcode: this.merchantcode,
      })
      .then((res: any) => {
        this.recommendInfo = res.data.baseInfo;
      });
  }

  protected loadList() {
    setTimeout(() => {
      const page = {
        ep: this.loadNumUp,
        sp: ++this.pageNum,
        qrinfoid: this.recommendInfo.qrinfoid,
        merchantcode: this.merchantcode,
      };
      api
        .post("/weixinmp/xsyx/recommend/getRecommendCusList", page)
        .then((res: any) => {
          const ss = res.data;
          if (ss.length != 0) {
            this.infoList = this.infoList.concat(ss);
          }
          if (ss.length == 0) {
            this.finished = true;
          }
          this.loading = false;
        });
    }, 1000);
  }

  protected showQRCodeDialog() {
    this.showQRCode = true;
    this.qrCodeText = this.recommendInfo.qrcodeurl;
  }

  protected showRecommendExplainDialog() {
    this.showRecommendExplain = true;
  }
}
